import React, { useState } from 'react';
import { Check, Link2, Linkedin, Mail } from 'lucide-react';
import { toast } from 'sonner';

const NAVY = '#0D1B2A';
const TEAL = '#00B4D8';

export const WATCH_PATH = '/watch';
export const watchUrl = (t) => `${window.location.origin}${WATCH_PATH}${t ? `?t=${Math.floor(t)}` : ''}`;

export function ShareButtons({ url, compact = false, dark = true }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Link copied');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Could not copy — the link is ' + url);
    }
  };
  const text = 'Run your entire MGA on one platform — watch the underAIter demo';
  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
  const mail = `mailto:?subject=${encodeURIComponent('Watch the underAIter demo (2½ minutes)')}&body=${encodeURIComponent(`${text}\n\n${url}`)}`;
  const base = `inline-flex items-center gap-2 rounded-full font-semibold transition-all duration-200 hover:-translate-y-0.5 ${compact ? 'px-3.5 py-1.5 text-xs' : 'px-4 py-2 text-sm'}`;
  const ghost = dark
    ? { border: '1px solid rgba(255,255,255,0.18)', color: '#E6EDF3', background: 'rgba(255,255,255,0.04)' }
    : { border: '1px solid rgba(13,27,42,0.15)', color: NAVY, background: '#fff' };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <button type="button" onClick={copy} className={base} style={{ background: TEAL, color: NAVY }} data-testid="share-copy-link">
        {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />} {copied ? 'Copied' : 'Copy link'}
      </button>
      <a href={linkedin} target="_blank" rel="noopener noreferrer" className={base} style={ghost} data-testid="share-linkedin">
        <Linkedin className="w-4 h-4" /> LinkedIn
      </a>
      <a href={mail} className={base} style={ghost} data-testid="share-email">
        <Mail className="w-4 h-4" /> Email
      </a>
    </div>
  );
}
